import { Link as RemixLink } from '@remix-run/react';

import useEnv from '~/hooks/useEnv';

function isClothingPlp(url: string) {
  const clothingPlpRegex = /^(\/(mens|womens))?\/clothing\/.*/;
  const clothingPdpRegex = /^\/clothing\/.*\/.*\/.*\//;

  return clothingPlpRegex.test(url) && !clothingPdpRegex.test(url);
}

function shouldRedirectToReact(url: string) {
  return isClothingPlp(url);
}

type Props = {
  children: React.ReactNode;
  className: string;
  to: string;
};

function ReactAppLink({ to, children, ...props }: Props) {
  const { SITE_BASE_URL } = useEnv();

  const url = new URL(to, SITE_BASE_URL);

  return (
    <a href={url.href} {...props}>
      {children}
    </a>
  );
}

export default function Link({ to, children, ...props }: Props) {
  return shouldRedirectToReact(to) ? (
    <ReactAppLink to={to} {...props}>
      {children}
    </ReactAppLink>
  ) : (
    <RemixLink to={to} {...props}>
      {children}
    </RemixLink>
  );
}
